import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalModule, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DialogHeaderComponent } from '../dialog-header/dialog-header.component';

@Component({
  selector: 'app-notes-dialog',
  standalone: true,
  imports: [CommonModule, NgbModalModule, DialogHeaderComponent],
  template: `
    <button type="button" class="ia-notes-trigger" [attr.aria-label]="(hasNotes ? 'Notes' : 'Add notes') + (itemLabel ? ' for ' + itemLabel : '')"
      (click)="open(dialog)">
      <img src="assets/media/icons/svg/icon-note.svg" alt="" width="16" height="16">
      {{ hasNotes ? 'Notes' : 'Add notes' }}
    </button>
    <ng-template #dialog let-modal>
      <app-dialog-header [titleId]="titleId" [description]="itemLabel ? 'SKU: ' + itemLabel : ''"
        (dismissed)="modal.dismiss()">Item notes</app-dialog-header>
      <div class="modal-body"><ng-container [ngTemplateOutlet]="content"></ng-container></div>
      <div class="modal-footer">
        <span class="ia-notes-help">Save each note before closing.</span>
        <button type="button" class="btn btn-secondary" (click)="modal.close()">Close</button>
      </div>
    </ng-template>`,
  styles: [`
    .ia-notes-trigger { display: inline-flex; align-items: center; gap: 6px; padding: 4px 0; border: 0; background: transparent;
      color: var(--ia-primary); font: inherit; font-size: 13px; line-height: 1.5; cursor: pointer; }
    .ia-notes-help { margin-right: auto; color: var(--ia-text-muted); font-size: 12px; }
  `]
})
export class NotesDialogComponent implements OnDestroy {
  private static nextId = 0;
  readonly titleId = `ia-notes-dialog-${NotesDialogComponent.nextId++}`;
  @Input() content: TemplateRef<unknown>;
  @Input() hasNotes = false;
  @Input() itemLabel: string | null | undefined;
  private dialogRef: NgbModalRef | undefined;

  constructor(private modal: NgbModal) {}

  open(dialog: TemplateRef<unknown>): void {
    if (this.dialogRef) return;
    this.dialogRef = this.modal.open(dialog, { ariaLabelledBy: this.titleId, centered: true, scrollable: true });
    this.dialogRef.result.then(() => this.dialogRef = undefined, () => this.dialogRef = undefined);
  }

  ngOnDestroy(): void {
    this.dialogRef?.dismiss();
  }
}
